import {useState} from "react";
import {eventBus} from "components/pagelayout/EventBus";
import type {CostUnitsDetailsProps} from "types/documentData";
import {DocumentDataField, DocumentDataGrid} from "./DocumentDataField.component";

// how many cost units are shown before "show more"
const COST_UNITS_LIMIT = 3;

/** The cost units of the document, under a heading of their own, the first three until the user asks for all. */
export const CostUnitsDetails = ({costUnitList, translate}: CostUnitsDetailsProps) => {
    const [showAll, setShowAll] = useState(false);
    const hiddenCostUnitsCount = costUnitList.length - COST_UNITS_LIMIT;
    const costUnits = showAll ? costUnitList : costUnitList.slice(0, COST_UNITS_LIMIT);

    const onShowMore = () => {
        setShowAll(true);
        // the panel grows, so the task details grid lays its rows out again
        eventBus.dispatch("@@grid/refreshGridLayout");
    };

    return (
        <section className="document-data__section" data-cy="taskDetail.detailsPanel.costUnits">
            <h3 className="document-data__section-title">{translate("documentData.costUnits")}</h3>
            <DocumentDataGrid>
                {costUnits.map((costUnit, index) =>
                    <DocumentDataField key={`${costUnit.dimensionName}-${costUnit.costUnitNumber}`}
                                       id={`costUnit-${index}`}
                                       label={costUnit.dimensionName || ""}
                                       value={`${costUnit.costUnitName || ""} (${costUnit.costUnitNumber ?? ""})`}/>)}
            </DocumentDataGrid>
            {hiddenCostUnitsCount > 0 && !showAll &&
                <button type="button" className="ga-link document-data__show-more" onClick={onShowMore}>
                    {translate("documentData.costUnitsShowMore", hiddenCostUnitsCount)}
                </button>}
        </section>
    );
};
